import { Component } from '@angular/core';

@Component({
  selector: 'ncp-aside',
  imports: [],
  templateUrl: './aside.component.html',
  styleUrl: './aside.component.scss',
})
export class AsideComponent {}
